import { useContext } from "react";
import { RecordContext } from "../../components/record/Record";
import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { useUser } from "../../api/useAuth";
import { isDepartmentAllowed } from "./departmentAccess";

export const ScheduledTasksDetailHeader = () => {
	const context = useContext(RecordContext);
	const { data: user } = useUser();

	const canEditDepartment = isDepartmentAllowed(user?.role?.id, context?.item?.department);

	return (
		<DetailHeader
			collection={context?.collection}
			editPermission={{
				canEdit: canEditDepartment,
				tooltip: "Sem permissão para editar tarefas deste departamento.",
			}}
		/>
	);
};
